document.addEventListener('DOMContentLoaded', function () {
  initCardSliders();
});

document.addEventListener('shopify:section:load', function () {
  initCardSliders();
});

function initCardSliders() {
  document.querySelectorAll('.card-slider:not([data-slider-init])').forEach(function (slider) {
    slider.setAttribute('data-slider-init', 'true');

    const track = slider.querySelector('.card-slider__track');
    const slides = slider.querySelectorAll('.card-slider__slide');
    const dots = slider.querySelectorAll('.card-slider__dot');

    if (slides.length <= 1) return;

    let current = 0;
    let interval = null;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function startAutoplay() {
      interval = setInterval(function () {
        goTo(current + 1);
      }, 2500);
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    // Touch/swipe support
    let startX = 0;
    slider.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
      startAutoplay();
    }, { passive: true });

    goTo(0);
    startAutoplay();
  });
}
